<template>
  <button  @click="goto(url)" 
        :class="`primary ${bt_shape} ${fill}`" 
        :style="buttonStyle" >
        <b-icon class="cent-vet interactive icon " 
          pack="fab" 
          :style="iconStyle"
          :icon="icon||'whatsapp'" 
          size="is-large" >
        </b-icon>
        <div class="my-auto">
            {{name}}
        </div>
    </button>
</template>

<script>

export default {
    name:'LinkButton',
    props:{
        url:{
            type:String,
            required:true
        },
        fill:{
          type:String,
          default: 'filled',
          validator: function (value) {
            return ['filled', 'empty'].indexOf(value) !== -1;
          },
        },
        icon:{
            type:String,
            required:true
        },
        name:{
            type:String,
            required:true
        },
        bt_shape:{
          type: String,
          default: 'smooth',
          validator: function (value) {
            return ['smooth', 'sharp'].indexOf(value) !== -1;
          },
        },
        mainColor:{
          type:String,
          required:true
        },
        secondaryColor:{
          type:String,
          required:false,
          default:"white"
        },
        shadow:{
          type:Number,
          required:false,
          default: 0
        }
    },
    computed:{
        iconStyle:function(){ 
          if(this.fill == "empty")
            return `fill:${this.mainColor} !important;`
          else
            return `fill: white !important;`
          },
        buttonStyle:function(){
          var style = ""
          if(this.fill == "empty"){
            style = `color:${this.mainColor};  border:solid 2px ${this.mainColor};`
          }
          else{
             style = `color: ${this.secondaryColor} ;  background-color: ${this.mainColor}; border:none;`
          }
          style += `box-shadow: 0px 4px ${this.shadow|| "4"}px rgba(0, 0, 0, 0.3);`
          return style;
          },
        
    },
    methods:{
      goto(url){
        // in other window
        var win = window.open(url);
        win.focus();
        // in same window
        // window.open(url,"_self");
    }
  }
}
</script>

<style lang="scss"  scoped>
//buttons
.primary{
  outline: none;
  width: 80%;
  height:15%;
  margin: 5% auto; 
  background: transparent;
  transition: border-radius .5s ease-in-out;
  display:flex;
  font-family: Montserrat;
  font-size: 19px;
}

button:active {
  border-style: outset;
}
.my-auto{
    margin: auto 0;
    width: stretch;
}
.icon{
  margin-left:7%;
}
.smooth{
  border-radius: 100px;
}
.sharp{
  border-radius:0;
}
.filled{
  border:none;
}
.empty{
  border:solid 2px
}
</style>